import { action, makeObservable, observable, reaction } from 'mobx';
import { UiStore } from './ui';
import { appConfig } from '../settings';
import { ICardListItem, IFilterParams, ISelect } from '../interfaces';
import { getCardList, getCardListCount, setUiTotal } from '../middleware';
import { apiParamsCleaner } from '../instruments';

export class CardsStore {
    private constructor() {
        makeObservable(this);
        reaction(
            () => this.forcedUpdateTime,
            () => {
                const UiStoreInstance = UiStore.getInstance();
                const params = UiStoreInstance.params;
                const cleanParams = apiParamsCleaner(params, this.filterParams);
                getCardList(cleanParams);
                getCardListCount(cleanParams);
            },
            {
                delay: appConfig.APIDelay,
            },
        );
    }

    private static instance: CardsStore;
    public static getInstance(): CardsStore {
        if (!CardsStore.instance) {
            CardsStore.instance = new CardsStore();
        }
        return CardsStore.instance;
    }

    @observable cardsList: ICardListItem[] = [];
    @action setCardsList(cardsList: ICardListItem[]): void {
        this.cardsList = cardsList;
    }

    @observable forcedUpdateTime = 0;
    @action setForcedUpdateTime(): void {
        this.forcedUpdateTime = Date.now();
    }

    // ------------ List params ------------
    @observable filterParams: IFilterParams = {
        cardSetId: true,
        companyId: true,
        isEimProvided: true,
        pageNumber: true,
        pageSize: true,
        search: true,
    };

    @observable select: ISelect[] = [];
    @observable totalSelect = 0;
    @action setSelect(select: ISelect[], totalSelect?: number): void {
        this.select = select;
        this.totalSelect = totalSelect || 0;
    }
    @action cleanStore(): void {
        this.cardsList = [];
        this.select = [];
        setUiTotal(0);
    }
}
